module.exports = __webpack_public_path__ + "static/media/backarrow.551f40af.svg";